import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations as en } from '../translations/en';
import { translations as es } from '../translations/es';
import FullBleedImage from '../components/FullBleedImage';
import ContactHero from '../components/ContactHero';
import ContactForm from '../components/ContactForm';

const translations = { en, es };

const Contact = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="font-inter bg-[#f5f5f7] text-[#1a2233] min-h-screen flex flex-col">
      <ContactHero
        title={t.contact.heroDescription}
        description=""
        image="/images/flowers3.jpg"
      />
      <section className="flex-1 py-20 px-6 md:px-0 bg-[#f5f5f7] flex flex-col items-center">
        <ContactForm t={t} language={language} />
      </section>
      <FullBleedImage 
        src="/images/party1.jpg"
        alt="Luxury wedding in Mexico"
        className="h-56 md:h-96"
        objectPosition="center 63%"
      />
    </div>
  );
};

export default Contact; 